import { HumanErrorMessages, MaxCheckableNumber } from '../../constants'
import { api } from '../../libs/api'
import pagination from './pagination'
import { MySet as Set } from '../../libs/polyfill'

export default {
  namespaced: true,

  modules: {
    pagination: pagination(),
  },

  state: {
    index: [],
    pageIds: [],
    checkedIds: new Set([]),
    pageCheckedIds: new Set([]),
    // 直近の fetchIndex のエラー（成功時は null）。avoidBlank() で使う。
    lastFetchError: null,
  },
  getters: {
    markedIds: state => new Set(state.index.map(({ id }) => id)),
    marked: (state, getters) => id => getters.markedIds.has(id),
    checkedIds: state => state.checkedIds,
    checkedCount: state => state.checkedIds.size,
    checked: (_, getters) => getters.checkedCount > 0,
    // eslint-disable-next-line
    pageAllChecked: (state, getters) => getters.checkedCount
      ? !state.pageIds.find(n => !state.pageCheckedIds.has(n))
      : false,
  },
  mutations: {
    index: (state, index) => {
      const pageIds = index.map(({ id }) => id)
      const pageCheckedIds = pageIds.filter(id => state.checkedIds.has(id))

      state.index = index
      state.pageIds = pageIds
      state.pageCheckedIds = new Set(pageCheckedIds)
    },
    check: (state, id) => {
      const newCheckedIds = new Set(state.checkedIds)
      const newPageCheckedIds = new Set(state.pageCheckedIds)
      if (Array.isArray(id)) {
        id.forEach((i) => {
          newCheckedIds.add(i)
          newPageCheckedIds.add(i)
        })
      } else {
        newCheckedIds.add(id)
        newPageCheckedIds.add(id)
      }
      state.checkedIds = newCheckedIds
      state.pageCheckedIds = newPageCheckedIds
    },
    uncheck: (state, id) => {
      const newCheckedIds = new Set(state.checkedIds)
      const newPageCheckedIds = new Set(state.pageCheckedIds)
      if (Array.isArray(id)) {
        id.forEach((i) => {
          newCheckedIds.delete(i)
          newPageCheckedIds.delete(i)
        })
      } else {
        newCheckedIds.delete(id)
        newPageCheckedIds.delete(id)
      }

      state.checkedIds = newCheckedIds
      state.pageCheckedIds = newPageCheckedIds
    },
    uncheckAll: (state) => {
      state.checkedIds.clear()
      state.pageCheckedIds.clear()

      state.checkedIds = new Set(state.checkedIds)
      state.pageCheckedIds = new Set(state.pageCheckedIds)
    },
    updateIndexForAccount: (state, checkedIds) => {
      const newIndex = state.index.map((company) => {
        if (checkedIds.includes(company.company_id.toString())) {
          const newCompany = Object.assign({}, company)
          newCompany.is_account = true
          return newCompany
        }
        return company
      })
      state.index = newIndex
    },
    lastFetchError: (state, error) => state.lastFetchError = error,
  },
  actions: {
    toggleCheck ({ commit, dispatch, state: { checkedIds } }, { checked, id }) {
      if (checked && checkedIds.size >= MaxCheckableNumber) {
        dispatch(
          'common/pushToastError',
          { error: HumanErrorMessages.CHECKED_LIMIT },
          { root: true },
        )
        return
      }

      checked
        ? commit('check', id)
        : commit('uncheck', id)
    },
    togglePageCheck (
      { commit, dispatch, getters: { pageAllChecked }, state: { pageIds, checkedIds } },
      { event }) {
      if (!pageAllChecked) {
        const nextCheckedIds = new Set(checkedIds)
        pageIds.forEach((i) => { nextCheckedIds.add(i) })
        if (nextCheckedIds.size > MaxCheckableNumber) {
          dispatch(
            'common/pushToastError',
            { error: HumanErrorMessages.CHECKED_LIMIT },
            { root: true },
          )
          event.preventDefault()
          return
        }
      }
      pageAllChecked
        ? commit('uncheck', pageIds)
        : commit('check', pageIds)
    },
    updateIndex: ({ commit, state: { index } }, id) => {
      const cloneIndex = []
      index.forEach((job) => { cloneIndex.push(job) })
      const idx = cloneIndex.findIndex(job => job.id === id)
      cloneIndex.splice(idx, 1)
      commit('index', cloneIndex)
    },
    async fetchIndex ({ commit, dispatch }, query) {
      try {
        const { meta, index: raw } = await api.fetchCompanyList(query)
        const index = raw.map(({ id: jobMarkId, created_at: createdAt, company }) => (
          {
            jobMarkId,
            ...company,
            marked: true,
            created_at: createdAt,
          }
        ))
        commit('pagination/newState', meta)
        commit('index', index)
        commit('lastFetchError', null)
      } catch (e) {
        commit('lastFetchError', e)
        const message = (Array.isArray(e) && e[0] && e[0].message) || HumanErrorMessages.SEARCH_FAILED
        dispatch(
          'common/pushToastError',
          { error: { message } },
          { root: true },
        )
        return Promise.reject(e)
      }
    },
    async add ({ commit }, { id, ids }) {
      await api.addJobMarkJobs({ ids: ids || [id] })
      commit('uncheck', ids || id)
    },
    async remove ({ commit }, { id, ids }) {
      await api.removeJobMarkJobs({ ids: ids || [id] })
      commit('uncheck', ids || id)
    },
    async removeCheckedJobs ({ commit, state: { checkedIds } }) {
      await api.removeJobMarkJobs({ ids: [...checkedIds] })
      commit('uncheckAll')
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/job-mark.js